import { Tooltip } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";

import EditIcon from "@mui/icons-material/Edit";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { SingleDocument } from "../../../types/document-management/document-management-types";
import { useMemo, useState } from "react";
import EditDocumentModal from "../modal/EditDocumentModal";
import DocumentAttachmentsModal from "../../Document-Management/modal/DocumentAttachmentsModal";
import { getParsedLocalStorage } from "../../../Utils/storage-utils";
import { extractUserDataFromPermission } from "../../../Utils/Utils";
import { Customer } from "../../../types";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";

type ModalStateType = { modal_open: boolean; modal_type: "edit" | "attachment" | "replacement" | null };
const DEFAULT_MODAL_STATE: ModalStateType = { modal_open: false, modal_type: null };

// function getTransformedRowData(data: SingleDocument) {
//   return {};
// }

const DocumentManagementTableActionColumn = (params: GridRenderCellParams) => {
  const row_data: SingleDocument = params.row;

  const [state, setState] = useState<ModalStateType>(DEFAULT_MODAL_STATE);

  function handleModalClose() {
    setState(DEFAULT_MODAL_STATE);
  }

  function handleModalOpen(type: "edit" | "attachment" | "replacement") {
    setState({ modal_open: true, modal_type: type });
  }

  const user_permissions = useMemo(() => {
    const permissions = getParsedLocalStorage("permissions");
    const _permissions = extractUserDataFromPermission(permissions);
    const { innerKeysList: sectionList, customerList, innerToCustomerNames } = _permissions;
    return {
      sectionList: sectionList as string[],
      customerList: customerList as Customer[],
      sectionToCustomerNameMap: innerToCustomerNames as Record<string, string[]>,
    };
  }, []);

  const DEFAULT_VALUES = useMemo(() => {
    const section_list: Set<string> = new Set();
    const allSections = Object.keys(user_permissions.sectionToCustomerNameMap);
    row_data.customers?.forEach((customer: any) => {
      if (allSections.includes(customer.section)) {
        section_list.add(customer.section);
      }
    });

    return {
      ...row_data,
      section: Array.from(section_list),
      station: row_data.customers,
      remarks: row_data.remark,
    };
  }, [user_permissions, row_data]);

  return (
    <>
      <div className="flex items-center gap-2">
        <Tooltip placement="bottom" title="Edit" disableInteractive onClick={() => handleModalOpen("edit")}>
          <EditIcon className="cursor-pointer" />
        </Tooltip>
        <Tooltip
          placement="bottom"
          title="Attachments"
          disableInteractive
          onClick={() => handleModalOpen("attachment")}
        >
          <AttachmentIcon className="cursor-pointer" />
        </Tooltip>
      </div>
      {state.modal_open && state.modal_type === "edit" && (
        <EditDocumentModal defaultValues={DEFAULT_VALUES} handleClose={handleModalClose} />
      )}
      {state.modal_open && state.modal_type === "attachment" && (
        <DocumentAttachmentsModal defaultValues={DEFAULT_VALUES} handleClose={handleModalClose} />
      )}
    </>
  );
};

export default DocumentManagementTableActionColumn;
